import { render, staticRenderFns } from "./ExamProfilesList.vue?vue&type=template&id=6cc7b0e2"
import script from "./ExamProfilesList.vue?vue&type=script&lang=js"
export * from "./ExamProfilesList.vue?vue&type=script&lang=js"
import style0 from "./ExamProfilesList.vue?vue&type=style&index=0&id=6cc7b0e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports